import { defaultTo, pipe } from 'ramda';

export const getContentTaxonomy = contentPaths => {
    return pipe(defaultTo([]), element => (Array.isArray(element) ? element : []))(contentPaths);
};
